module.exports = __webpack_public_path__ + "static/media/logo.c18a04f3.svg";